import { SmsEspAccount } from 'modules/graphql/types';
import { Skeleton } from 'ui/skeleton';
import { SmsAccount } from './SmsAccount';
import { SmsAccountsEmptyState } from './SmsAccountsEmptyState';
import { useSendingPlatformsQueryContext } from '../../../contexts';
import { SendingPlatform } from '../../../constants';

export const SmsAccountsSection = ({ sendingPlatform }: { sendingPlatform: SendingPlatform }) => {
  const { isLoadingEssentialData, espAccountsBySendingPlatform } =
    useSendingPlatformsQueryContext();

  const espAccounts = espAccountsBySendingPlatform[sendingPlatform] || [];

  if (isLoadingEssentialData) return <Skeleton height={265} />;

  if (!espAccounts.length) return <SmsAccountsEmptyState sendingPlatform={sendingPlatform} />;

  return (
    <>
      {espAccounts.map((espAccount) => (
        <SmsAccount key={espAccount.id} espAccount={espAccount as SmsEspAccount} />
      ))}
    </>
  );
};
